export default {
	CREATE: 'add',
	UPDATE: 'update',
	REMOVE: 'remove',
};
